export const Swiper = {};
export const Slide = { height: '100vh' };
